// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"vt_a bhc_b"};